import { FunctionComponent, useState, useCallback } from 'react'
import { MdPlayArrow } from 'react-icons/md'

import * as Yup from 'yup'

import { steps } from '../../'
import iconConj from 'shared/assets/icons/icon-conj.svg'
import Form, { IProps as FormProps } from 'shared/components/Form'
import Input from 'shared/components/Input'
import Page from 'shared/components/Page'
import { colors } from 'shared/styles/colors'
import { IAnttProps } from './AnttComponent.types'
import { ContainerForm, StyledButton } from './styles'

const Antt: FunctionComponent<IAnttProps> = ({
  setSelectedStep,
  validateAnttImpl,
}) => {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [antt] = useState(() => {
    if (localStorage.getItem('@TMov:SignUpAntt')) {
      return localStorage.getItem('@TMov:SignUpAntt')
    }

    return ''
  })

  const handleSubmit = useCallback(
    async (values: FormProps['values']) => {
      setLoading(true)
      setErrorMessage('')

      try {
        const schema = Yup.object().shape({
          antt: Yup.string().required(),
        })

        await schema.validate(values, {
          abortEarly: false,
        })

        const cnpj = localStorage.getItem('@TMov:SignUpCnpj')

        const responseAntt = await validateAnttImpl.execute({
          antt: values.antt,
          cnpj,
        })

        if (!responseAntt?.aptoTransporte) {
          setErrorMessage(
            `Erro ao tentar validar a ANTT: ${responseAntt.mensagem}`,
          )
          setLoading(false)
          return
        }

        localStorage.setItem('@TMov:SignUpAntt', values.antt)

        setSelectedStep(steps.NewPassword)
      } catch (e: unknown) {
        setLoading(false)
        if (e instanceof Yup.ValidationError) {
          setErrorMessage('O campo Antt, é obrigatório')
        } else if (e instanceof Error) {
          setErrorMessage(e.message)
        } else {
          setErrorMessage('Erro ao tentar validar o antt')
        }
      }
    },
    [validateAnttImpl],
  )

  return (
    <Page
      title="Informe o número da ANTT:"
      icon={iconConj}
      goBackTo={() => {
        setSelectedStep(steps.CepAddress)
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center', flex: 1 }}>
        <Form
          onSubmit={handleSubmit}
          initialValues={{ antt }}
          validationSchema={() => ({
            antt: Yup.string().required(),
          })}
        >
          {formControl => (
            <ContainerForm>
              <Input
                placeholder="Digite apenas números"
                name="antt"
                formControl={formControl}
                errorMessage={errorMessage}
                maxLength={14}
              />

              <StyledButton
                color={colors.green}
                type="submit"
                loading={loading}
                disabled={loading}
                onClick={formControl.handleSubmit}
              >
                <MdPlayArrow /> Próximo
              </StyledButton>
            </ContainerForm>
          )}
        </Form>
      </div>
    </Page>
  )
}

export default Antt
